import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer text-white">
         © 2025 Probabilité Sport. Tous droits réservés 
        <a  target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">CoteoAI</a>
    </div>`
})
export class AppFooter {}
